import React from 'react';

type Props = {color?: string};

export const ProfileTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={24} fill='none'>
    <circle cx='25' cy='9' r='3.5' stroke={color} strokeWidth='1.5' fill='none'/>
    <path
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      fill='none'
      d='M18 20c0-3.866 3.134-7 7-7s7 3.134 7 7'
    />
  </svg>
);
